<template>
  <div class="wrapper" ref="scrollContainer" @scroll="checkScroll">
    <v-head v-show="isShow"></v-head>
    <v-menu v-show="isShow"></v-menu>
    <div class="content">
      <transition name="move" mode="out-in">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </div>
    <v-footer v-show="isShow"></v-footer>
    <div class="scrollToTop" v-if="toTopIsShow" @click="scrollToTop">
      <img src="@/assets/img/go-back.png" />
    </div>
  </div>
</template>
<script>
  import vHead from "@/components/common/Header";
  import vMenu from "@/components/common/menu";
  import vFooter from "@/components/common/Footer";
  export default {
    data: function() {
      return {
        isShow: false,
        toTopIsShow: true,
        scrollThreshold: 100 //滚动阈值
      };
    },
    components: {
      vHead,
      vMenu,
      vFooter
    },
    beforeRouteUpdate(to, from, next) {
       if (
        to.name === "关于我们" ||
        to.name === "广告投放" ||
        to.name === "开放平台" ||
        to.name === "公告声明" ||
        to.name === "应用下载"
      ) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
      next();
    },
    beforeRouteEnter(to, from, next) {
      if (
        to.name === "关于我们" ||
        to.name === "广告投放" ||
        to.name === "开放平台" ||
        to.name === "公告声明" ||
        to.name === "应用下载"
      ) {
        next(vm => {
          vm.isShow = true;
        });
      }else{
        next(vm => {
          vm.isShow = false;
        });
      }
    },
    created() {},
    mounted() {

      //初始化时调用一次，确保按钮的初始状态
      this.checkScroll();
    },
    watch: {},
    methods: {
      //判断返回按钮是否显示
      checkScroll(e) {
        var scrollTop = this.$refs.scrollContainer.scrollTop;
        this.toTopIsShow = scrollTop > this.scrollThreshold;
      },
      //返回顶部
      scrollToTop() {
        this.$refs.scrollContainer.scrollTop = 0;
      }
    }
  };
</script>

<style scoped>
  .wrapper {
    position: relative;
    min-width: 1320px;
    scroll-behavior: smooth;
    transition: all 0.5s ease;
    overflow-y: auto;
    /* background: plum */
  }
  .scrollToTop {
    position: fixed;
    right: 30px;
    bottom: 150px;
  }
</style>
